import script from "./NewRFP.vue?vue&type=script&setup=true&lang=js"
export * from "./NewRFP.vue?vue&type=script&setup=true&lang=js"

import "./NewRFP.vue?vue&type=style&index=0&id=154fb44e&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-154fb44e"]])

export default __exports__